module.exports = __webpack_public_path__ + "assets/img/buy_word_course3.5ba06035.png";